import React, { useState } from 'react';



export const Noc = (props) => {
    const [showImage, setShowImage] = useState(true);
    // hide NOC code until md size  
    const [classNameForNoc, setClassNameForNoc] = useState(props?.hideNocCode ? "me-1 d-none d-md-block" : "me-1");
    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(false);
        setClassNameForNoc("me-1")  //always show NOC code when flag image is missing
    };

    const noc = props.code;
    const nocDesc = (props.longDescription) ? props.longDescription : props.description;

    return (
        <div className="wrsNoc" >
            {showImage ? (
                <div className="flag">
                    <img
                        aria-hidden="true"
                        src={`/assets/images/flags/${noc}.png`}
                        alt={nocDesc}
                        title={nocDesc}
                        onError={hideImg} />
                </div>
            ) : ('')}
            { props.showOnlyImage ? '' : props?.showLongDesc===true ? (nocDesc) : (<abbr className={classNameForNoc} title={nocDesc}>{noc}</abbr>) }
        </div>
    )
};

export const NocMemo = React.memo(Noc);

export default Noc
